module.exports = __webpack_public_path__ + "static/GO-patient-form-56d419873e95c792f4732977f56c4559.pdf";